<template>
	<div>
		<v-row v-for="(data, indexItem) in formItemsList" :key="indexItem">
			<v-col v-if="isTitleItem(data)" class="py-0 px-0 mb-0 mt-0">
				<h4>{{ data.formItem.fitelinetext }}</h4>
			</v-col>
			<v-col v-if="isTextItem(data)" class="py-0 px-0 mb-0 mt-0">
				<p class="mb-0" v-html="data.formItem.fitelinetext"></p>
			</v-col>
			<v-col v-if="isListItem(data)" class="py-0 px-0 mb-0 mt-0">
				<v-checkbox
					class="ml-0 py-0 px-0 mt-0 element1-height" style="max-height: 2rem; margin-bottom: 0.4rem;"
					v-model="checkBox[data.formItem.foitid]"
					@change="(value) => changeValueCheckBox(data.formItem.foitid, value)"
					:label="data.formItem.fitelinetext"
					:key="`${data.formItem.foitid}-${updateCheckBoxes}`"
					true-value="1"
					false-value="0"
				></v-checkbox>
			</v-col>
			<v-col v-if="isAttributeCommonItem(data)" class="py-0">
				<v-row class="mt-0" v-for="(formItemsValueText, indexformItemsValueText) in data.formItemsValueText" :key="indexformItemsValueText">
					<v-col class="py-0 px-0 mb-0 mt-0">
						<v-checkbox
							style="min-height: 3rem; margin-bottom: 0rem;"
							class="ml-0 py-0 px-0 mt-0 element2-height"
							v-model="checkBoxValue[formItemsValueText.fivtid]"
							@change="(value) => changeOptionValueCheckBox(formItemsValueText.fivtid, value)"
							:label="formItemsValueText.fivtvalucommontext"
							:key="`${formItemsValueText.fivtid}-${updateCheckBoxes}`"
							true-value="1"
							false-value="0"
						></v-checkbox>
					</v-col>
				</v-row>
			</v-col>
			<v-col v-if="isAttributeGroupEvent(data)" class="py-0">
				<v-row class="mt-0" v-for="(formItemsValueText, indexformItemsValueText) in data.formItemsValueText" :key="indexformItemsValueText">
					<v-col class="py-0 px-0 mb-0 mt-0">
						<v-checkbox
							style="min-height: 3rem; margin-bottom: 0rem;"
							class="ml-0 py-1 px-0 mt-0 element2-height"
							v-model="checkBoxValue[formItemsValueText.fivtid]"
							@change="(value) => changeOptionValueCheckBox(formItemsValueText.fivtid, value)"
							:label="formItemsValueText.fivtvaluevgrtext"
							:key="`${formItemsValueText.fivtid}-${updateCheckBoxes}`"
							true-value="1"
							false-value="0"
						></v-checkbox>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: Array,
			required: true
		},
		checkBoxUniq: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			itemsTypes: {
				TITULO: 1,
				TEXTO: 2,
				LISTA: 3,
				ATTRIBUTE_COMMON: 4,
				ATTRIBUTE_GRUPO_EVENT: 5
			},
			checkBox: {},
			checkBoxValue: {},
			updateCheckBoxes: 0,
			updateCheckBoxes: 0
		};
	},
	computed: {
		formItemsList: {
			get: function () {
				return this.sortOrderAsc(this.value);
			},
			set: function (newValue) {
				this.$emit('input', newValue);
			}
		},
		test() {
			return this.checkBox;
		}
	},
	methods: {
		changeValueCheckBox(checkBoxid, data) {
			//console.log("checkBoxid",checkBoxid);
			//console.log("data",data);
			if (this.checkBoxUniq) {
				const allCheckBox = Object.keys(this.checkBox);
				allCheckBox.map((key) => {
					//console.log("key",key);
					this.checkBox[key] = key == checkBoxid ? data : '0';
				});
			} else {
				this.checkBox[checkBoxid] = data;
			}
			//console.log("this.checkBox", this.checkBox);
			//console.log("this.checkBoxValue", this.checkBoxValue);
			this.updateCheckBoxes++;
			this.$emit('eventCheck', this.checkBox, this.checkBoxValue);
		},
		changeOptionValueCheckBox(checkBoxid, data) {
			//console.log("checkBoxid", checkBoxid);
			//console.log("data", data);
			if (this.checkBoxUniq) {
				const allCheckBox = Object.keys(this.checkBoxValue);
				allCheckBox.map((key) => {
					//console.log("key",key);
					this.checkBoxValue[key] = key == checkBoxid ? data : '0';
				});			
			} else {
				this.checkBoxValue[checkBoxid] = data;
			}
			//console.log("this.checkBox", this.checkBox);
			//console.log("this.checkBoxValue", this.checkBoxValue);
			this.updateCheckBoxes++;
			this.$emit('eventCheck', this.checkBox, this.checkBoxValue);		

		},
		sortOrderAsc(list) {
			return list.sort((a, b) => (a.formItem.foitorder < b.formItem.foitorder ? -1 : 1));
		},
		isTitleItem({ formItem }) {
			return formItem.foittype === this.itemsTypes.TITULO;
		},
		isTextItem({ formItem }) {
			return formItem.foittype === this.itemsTypes.TEXTO;
		},
		isListItem({ formItem }) {
			return formItem.foittype === this.itemsTypes.LISTA;
		},
		isAttributeCommonItem({ formItem }) {
			return formItem.foittype === this.itemsTypes.ATTRIBUTE_COMMON;
		},
		isAttributeGroupEvent({ formItem }) {
			return formItem.foittype === this.itemsTypes.ATTRIBUTE_GRUPO_EVENT;
		}
	},
	created() {
		this.value.map((data) => {
			if (data.formItem.foittype == this.itemsTypes.LISTA) {
				this.checkBox[data.formItem.foitid] = '0';
				//console.log("this.checkBox", this.checkBox);
			} else {
				for (let index = 0; index < data.formItemsValueText.length; index++) {
					this.checkBoxValue[data.formItemsValueText[index].fivtid] = '0';
				}
				//console.log("this.checkBoxValue", this.checkBoxValue);
			}
		});
	}
};
</script>
